import { all, takeLatest, call, put } from 'redux-saga/effects';

import { getFeatureItemsActions } from '@/redux/actions/service-directory/feature-item';
import { FeatureItemInstance } from '@/services/service-directory/feature-item';
import { FeatureItem, FeatureType, OptionFilter } from '@/types';
import { camelCase } from '@/utils';
import { ActionType } from 'deox';

export function* getFeatureItemsSaga(action: ActionType<typeof getFeatureItemsActions.request>) {
  try {
    const { arrayActiveFeature } = action.payload;
    const response = yield call(FeatureItemInstance.fetchFeatureItem);
    const apiOptions: { [checkbox: string]: OptionFilter } = {};
    let appOptions: { [checkbox: string]: OptionFilter } = {};
    let entityOptions: { [checkbox: string]: OptionFilter } = {};
    const checkActive = (featureItem: string) => {
      if (arrayActiveFeature && arrayActiveFeature.length > 0) {
        const tranformValue = camelCase(featureItem).replace('&', '|');
        return arrayActiveFeature.findIndex((feature) => feature === tranformValue) !== -1;
      }
      return false;
    };
    response.forEach((featureItem: FeatureItem) => {
      // eslint-disable-next-line default-case
      switch (featureItem.featureGroup.type.toLowerCase()) {
        case FeatureType.API: {
          apiOptions[camelCase(featureItem.featureItem)] = {
            label: featureItem.featureItem,
            dotColor: undefined,
            checked: false,
            value: featureItem.featureItem,
          };
          break;
        }
        case FeatureType.APP: {
          appOptions[camelCase(featureItem.featureItem)] = {
            label: featureItem.featureItem,
            dotColor: undefined,
            checked: checkActive(featureItem.featureItem),
            value: featureItem.featureItem,
          };
          break;
        }
        case FeatureType.ENTITY: {
          entityOptions[camelCase(featureItem.featureItem)] = {
            label: featureItem.featureItem,
            dotColor: undefined,
            checked: checkActive(featureItem.featureItem),
            value: featureItem.featureItem,
          };
          break;
        }
      }
    });

    // Sort checked will go first
    appOptions = sortCheckedValues(appOptions);
    entityOptions = sortCheckedValues(entityOptions);
    yield put(getFeatureItemsActions.success(response, apiOptions, appOptions, entityOptions));
  } catch (err) {
    yield put(getFeatureItemsActions.failure(err));
  }
}

const sortCheckedValues = (values: { [checkbox: string]: OptionFilter }) => {
  return Object.keys(values)
    .sort((a, b) => {
      const value1 = values[a].checked ? 1 : 0;
      const value2 = values[b].checked ? 1 : 0;
      return value2 - value1;
    })
    .reduce((obj: any, key) => {
      // eslint-disable-next-line no-param-reassign
      obj[key] = values[key];
      return obj;
    }, {});
};

export default function* root() {
  yield all([takeLatest(getFeatureItemsActions.request.type, getFeatureItemsSaga)]);
}
